import { TextBox, TextBoxProps } from '../TextBox';
import styles from './TextBoxField.module.css';
import { InputLabel } from '../TextBox/TextBox';

export interface TextFieldProps extends TextBoxProps {
    label: string;
    required?: boolean;
    notices?: string[];
    errorMessage?: string;
}

export const TextField = (props: TextFieldProps) => {
    const { notices, errorMessage } = props;

    const listNotice =
        notices?.map((notice, index) => {
            return (
                <p className={styles['of-notice']} key={index}>
                    <span className={styles.symbol}>※</span>
                    <small>{notice}</small>
                </p>
            );
        });

    return (
        <div className={styles['mod-form-txt']}>
            <InputLabel id={props.id} text={props.label} required={props.required} />
            {errorMessage ? <p className={styles['of-invalid']}>{errorMessage}</p> : null}
            {listNotice}
            <TextBox
                id={props.id}
                placeholder={props.placeholder}
                maxLength={props.maxLength}
                type={props.type}
                aria-invalid={props.invalid}
                disabled={props.disabled}
                min={props.min}
                max={props.max}
                required={props.required}
                pattern={props.pattern}
                aria-label={props.ariaLabel}
                numberLine={props.numberLine}
                value={props.value}
                onChange={props.onChange}
            />
        </div>
    );
};
